import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 13H5v-2h14v2z"
}), 'RemoveOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/RemoveOutlined.js
// module id = 5724
// module chunks = 2